import * as React from "react"
import Image from "gatsby-image"

// Styles
import "./_four-image-grid.scss"

// Components
import { Container } from "../StyledComponents/layoutComponentStyles"
import { $mobile } from "../../utils/breakpoints"

interface FourImageGridProps {
  module: any
}

/*

 







*/

const FourImageGrid: React.FunctionComponent<FourImageGridProps> = ({ module }) => {
  return (
    <Container sixteenClm={!$mobile}>
      <div className='project-img__grid'>
        {module.images.map((image: any, index: number) => (
          <div className={`grid-img__${index + 1}`} key={index}>
            {image.image.asset.extension === "gif" ? (
              <img src={image.image.asset.url} alt={image.altText} className='project-img-grid__asset' />
            ) : (
              <Image
                fluid={image.image.asset.fluid}
                alt={image.altText}
                style={{ height: "inherit" }}
                className='project-img-grid__asset'
              />
            )}
          </div>
        ))}
      </div>
    </Container>
  )
}

export default FourImageGrid
